import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import ScrollReveal from "scrollreveal";
import { AbstractPage } from "src/app/pages/abstract.page";
import { ContactFormService } from "src/app/services/contactForm.service";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-total-body-scan-landing",
  templateUrl: "./total-body-scan.landing.html",
  styleUrls: ["./total-body-scan.landing.scss"],
})
export class TotalBodyScanLandingPage
  extends AbstractPage
  implements OnInit, AfterViewInit
{
  loadingForm = false;
  submitted = false;
  formErrors = "";
  showMoreInfo = false;
  squareLink = "https://square.link/u/vr769yh2";

  constructor(
    public meta: Meta
  ) {
    super();
  }

  ngOnInit(): void {
    
    this.meta.addTags([
      { name: "description", content: "Descubre nuestro servicio de escaneo corporal total que proporciona imágenes tridimensionales detalladas de todos los órganos principales, permitiendo diagnósticos tempranos y precisos." },
      { name: "keywords", content: "escaneo corporal total, diagnóstico preventivo, imágenes 3D, chequeo médico completo, salud integral, detección temprana, MyTreat Health" },
      { property: "og:title", content: "Escaneo Corporal Total - MyTreat Health" },
      { property: "og:description", content: "Obtén una visión completa de tu salud con nuestro escaneo corporal total, que ofrece imágenes 3D detalladas de tus órganos principales para diagnósticos precisos." },
      { property: "og:image", content: "https://www.mytreat.health/api/files/marketplace/0e5c6c16-ecfa-410c-a6eb-788c8977845c.png" },
      { property: "og:url", content: "https://www.mytreat.health/en/total-body-scan/landing" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Escaneo Corporal Total - MyTreat Health" },
      { name: "twitter:description", content: "Obtén una visión completa de tu salud con nuestro escaneo corporal total." },
      { name: "twitter:image", content: "https://www.mytreat.health/api/files/marketplace/0e5c6c16-ecfa-410c-a6eb-788c8977845c.png" }
    ]);
  }

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const itemNumber = entry.target.getAttribute("data-item");
          const indicator = document.querySelector(
            `span[data-item='${itemNumber}']`
          );
          if (entry.isIntersecting) {
            indicator.classList.add("in-view");
          } else {
            indicator.classList.remove("in-view");
          }
        });
      },
      {
        threshold: 0.65, // Adjust the threshold as needed
      }
    );

    document.querySelectorAll("article[data-item]").forEach((element) => {
      observer.observe(element);
    });

    console.log("initializing scroll reveal");
    const sr = ScrollReveal();

    for (let i = 0; i < 6; i++) {
      sr.reveal(`.bottom-reveal:nth-child(${i + 1}) `, {
        duration: 500,
        origin: "bottom",
        distance: "75px",
        easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        reset: false,
        mobile: false,
        delay: i * 200,
        viewOffset: {
          bottom: 100,
        },
      });
    }

    sr.reveal(`.left-reveal`, {
      duration: 500,
      origin: "left",
      distance: "75px",
      easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      reset: false,
      delay: 200,
      mobile: false,
      viewOffset: {
        bottom: 100,
      },
    });

    sr.reveal(`.right-reveal`, {
      duration: 500,
      origin: "right",
      distance: "175px",
      easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      reset: false,
      delay: 200,
      mobile: false,
      viewOffset: {
        bottom: 100,
      },
    });
  }

  pageTitle(): string {
    return "MyTreat - Total Body Scan";
  }

  scrollTo(id: string) {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
      block: id === "benefits" ? "start" : "center",
    });
  }

  toggleShowMore() {
    this.showMoreInfo = !this.showMoreInfo;
  }
}
